<template>
  <div :class="[`widget_${id}`, currentView]" :type="current.type">
    <component :is="reference" :widget="current"></component>
  </div>
</template>

<script>
import Mixin from '@/components/page-editor/Mixin.js'

export default {
  name: 'Widget',
  mixins: [Mixin],
  computed: {
    reference() {
      return () => import(`@/components/page-editor/${this.current.type}.vue`)
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='widget_'] {
  max-width: 100%;
  &[type='widget/Form'],
  &[type='widget/Text'],
  &[type='widget/DynamicText'],
  &[type='widget/facebookComments'],
  &[type='widget/Iframe'],
  &[type='widget/Upsell'],
  &[type='widget/Video'] {
    width: 100%;
  }
  &[type='widget/Image'] {
    width: 100%;
    display: inline-block;
    text-align: center;
  }
}
</style>
